const COOKIE_CONSENT_KEY = "cookieConsent";
const QR_TEMP_CONSENT_UNTIL_KEY = "qrTempConsentUntil";
const THREE_HOURS_IN_MS = 3 * 60 * 60 * 1000;

const isBrowser = () => typeof window !== "undefined";

const readStoredConsent = () => {
  if (!isBrowser()) {
    return null;
  }

  return window.localStorage.getItem(COOKIE_CONSENT_KEY);
};

export const hasActiveQrTempConsent = () => {
  if (!isBrowser()) {
    return false;
  }

  const storedUntil = window.localStorage.getItem(QR_TEMP_CONSENT_UNTIL_KEY);

  if (!storedUntil) {
    return false;
  }

  const expiresAt = Number(storedUntil);

  if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
    window.localStorage.removeItem(QR_TEMP_CONSENT_UNTIL_KEY);
    return false;
  }

  return true;
};

export const getAnalyticsConsentState = () => {
  const storedConsent = readStoredConsent();

  if (storedConsent === "all") {
    return "all";
  }

  if (hasActiveQrTempConsent()) {
    return "all";
  }

  return storedConsent;
};

export const setStoredCookieConsent = (value) => {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.setItem(COOKIE_CONSENT_KEY, value);
};

export const setQrTemporaryConsent = (durationMs = THREE_HOURS_IN_MS) => {
  if (!isBrowser()) {
    return;
  }

  const expiresAt = Date.now() + durationMs;
  window.localStorage.setItem(QR_TEMP_CONSENT_UNTIL_KEY, String(expiresAt));
};

export const clearQrTemporaryConsent = () => {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.removeItem(QR_TEMP_CONSENT_UNTIL_KEY);
};
